var $e73bf42412feb220$exports = {};
const $e73bf42412feb220$var$navlinks = document.querySelectorAll(".navbar__links--link");
const $e73bf42412feb220$var$dropdownIcons = document.querySelectorAll(".navbar__links--link__icon");
const $e73bf42412feb220$var$dropdowns = document.querySelectorAll(".navbar__dropdown");
for(let i = 0; i <= $e73bf42412feb220$var$navlinks.length; i++)$e73bf42412feb220$var$navlinks[i].addEventListener("click", ()=>{
    $e73bf42412feb220$var$dropdownIcons[i].classList.toggle("drop-expanded");
    $e73bf42412feb220$var$dropdowns[i].classList.toggle("dropdown-show");
});


//# sourceMappingURL=index.52a39f1f.js.map
